/* eslint-disable */
// ─── Tokenizer ────────────────────────────────────────────────────────────────
// Pure function. Splits normalized input into meaningful tokens.

const STOPWORDS = new Set([
    'the', 'a', 'an', 'for', 'to', 'of', 'my', 'our', 'in', 'on', 'at',
    'with', 'and', 'or', 'by', 'from', 'that', 'this', 'is', 'it', 'its',
    'as', 'be', 'was', 'are', 'were', 'has', 'had', 'do', 'does',
    'did', 'will', 'would', 'could', 'should', 'may', 'might', 'can',
    'me', 'we', 'us', 'i',
]);

/**
 * Tokenize a normalized string into meaningful lowercase tokens.
 * - Splits on whitespace and punctuation boundaries (except hyphens/dots in IDs)
 * - Removes stopwords
 * - Removes empty tokens
 * - Preserves ordering (important for verb-first detection)
 */
export function tokenize(normalized) {
    // Split on spaces; further split word-only tokens on forward-slash
    const raw = normalized
        .split(/\s+/)
        .flatMap(t => {
            if (t.startsWith('/')) {
                // Keep the leading slash for command tokens like "/search"
                const parts = t.slice(1).split('/').filter(Boolean);
                return ['/' + parts[0], ...parts.slice(1)];
            }
            return t.split('/').filter(Boolean);
        });

    return raw
        .map(t => t.trim().toLowerCase())
        .filter(t => t.length > 0)
        .filter(t => !STOPWORDS.has(t));
}

/**
 * Returns true if ALL items in `needles` appear somewhere in `haystack`.
 */
export function tokensIncludeAll(haystack, needles) {
    return needles.every(n => haystack.includes(n));
}

/**
 * Returns true if ANY item in `needles` appears in `haystack`.
 */
export function tokensIncludeAny(haystack, needles) {
    return needles.some(n => haystack.includes(n));
}
